module.exports = __webpack_public_path__ + "img/PopUP-Payment-3.623cf10c.png";